import styled from 'styled-components/macro';

export const ScQRCode = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  background: ${({ theme }) => theme.whiteColor};
  margin: 16px auto;
`;
